module.exports = __webpack_public_path__ + "static/img/apple-store-badge-es-CO.bbd6b5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/apple-store-badge-es-CO.png
// module id = wgGB
// module chunks = 1